import * as React from 'react';

import { calculateLargestWithdrawal } from '../../../providers/TransactionsProvider';
import { toCurrency } from '../../../utils/formatting';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface ILargestWithdrawalRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  colored?: boolean;
  showSign?: boolean;
}

const LargestWithdrawalRow = ({
  transactions,
  dateRange,
  colored = false,
  showSign = false,
}: ILargestWithdrawalRowProps) => {
  const value = React.useMemo(() => calculateLargestWithdrawal(transactions, dateRange), [transactions, dateRange]);

  const valueClassName = React.useMemo(() => {
    if (colored) {
      return value >= 0 ? 'text-success-primary' : 'text-error-primary';
    }
    return '';
  }, [colored, value]);

  const formattedValue = toCurrency(value, { showSign });

  return <Widget.Row label="Largest withdrawal" value={formattedValue} valueClassName={valueClassName} />;
};

export default LargestWithdrawalRow;
